<template>
  <SeoLandingPage :page="page" />
</template>

<script setup>
import page from "#build/page-data/solutions/event-planning-software.mjs";
</script>
